import { render } from "./ResearcherInnovationSideBar.vue?vue&type=template&id=c1156924"
import script from "./ResearcherInnovationSideBar.vue?vue&type=script&lang=js"
export * from "./ResearcherInnovationSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__